
import { Component, Vue } from 'vue-property-decorator'
import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
import {
  getGoodsListOfCategory,
  getShopGoodsBrandList,
  getShopGoodsClassLis, getShopGoodsTagList, ShopGoodsBrandListDto,
  ShopGoodsClassListDto, ShopGoodsListDto, ShopGoodsTagListDto, newArrivalList, hotSaleList
} from "@/api/shoppingMall";
import DropItemSelector from "@/components/DropItemSelector/index.vue";
import { Getter } from "vuex-class";

@Component({
  name: 'GoodsClass',
  components: { GoodsResultCard, DropItemSelector }
})
export default class GoodsClass extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  /* 当前选择的分类id */
  categoryId = ''
  /* 当前选择的分类parentId */
  parentId = ''
  /* 三级分类时选择的分类值 */
  threeId = ''
  /* 当前选择的分类级别 */
  currentLevel = ''
  // 排序字段 价格：1，销量：2，编码：3
  orderField = ''
  // 排序类型 Up:升序，Down: 降序
  orderType = ''
  sortValue = ''
  /* 排序选项列表 */
  sortOption = [
    { text: '默认排序', value: '' },
    { text: '按价格升序', value: '1-Up' },
    { text: '按价格降序', value: '1-Down' },
    { text: '按销量升序', value: '2-Up' },
    { text: '按销量降序', value: '2-Down' },
    { text: '按商品编码升序', value: '3-Up' },
    { text: '按商品编码降序', value: '3-Down' },
  ]
  /* 分类列表 */
  classList: ShopGoodsClassListDto[] = []
  /* 分类三级列表 */
  threeLevelList: ShopGoodsClassListDto[] = []
  /* 品牌筛选值 */
  brandValue = []
  /* 品牌列表 */
  brandList: ShopGoodsBrandListDto[] = []
  /* 标签筛选值 */
  tagValue = []
  /* 标签列表 */
  tagList: ShopGoodsTagListDto[] = []
  /* 分类筛选下商品列表 */
  shopGoodsList: ShopGoodsListDto[] = []

  params = {
    pageIndex: 1,
    pageSize: 10
  }
  refreshing = false
  loading = false
  finished = false

  created () {
    this.getClassList()
    this.getBrandList()
    this.getGoodsList()
  }

  /**
   * 获取商品分类列表
   * */
  getClassList () {
    const param = {
      companyId: this.providerId,
      categoryLevel: '0',
      isPage: false
    }
    getShopGoodsClassLis(param, false).then((res) => {
      this.classList = res.data || []
      this.initClassList()
    })
  }

  /**
   * 初始化商品分类列表
   */
  initClassList () {
    if (this.classList && this.classList.length > 0) {
      this.classList.forEach((item) => {
        item.isCollapse = false
      })
      this.classList = JSON.parse(JSON.stringify(this.classList))
    }
  }

  /**
   * 切换二级分类展开状态
   * @param index 下标
   */
  collapseChange (index: number) {
    if (this.classList[index].isCollapse) {
      this.$set(this.classList[index], 'isCollapse', false)
    } else {
      this.$set(this.classList[index], 'isCollapse', true)
    }
  }

  /**
   * 选择分类改变当前左侧选中的分类id
   * @param param 分类数据对象或分类类别字符串
   */
  async changeId (param: ShopGoodsClassListDto | string) {
    this.threeId = ''
    // 手动添加的商品分类（全部、新品上架、热卖推荐）
    if (typeof param === 'string') {
      if (this.categoryId === param) return false
      this.categoryId = param
      this.parentId = ''
      this.currentLevel = ''
    } else { // 接口获取的商品分类
      if (this.categoryId === param.categoryId) return false
      this.categoryId = param.categoryId
      this.parentId = param.parentId
      this.currentLevel = param.categoryLevel

      if (this.currentLevel === '2' && param.children && param.children.length > 0) {
        this.threeLevelList = param.children
      } else {
        this.threeLevelList = []
      }
    }
    this.params.pageIndex = 1
    await this.getGoodsList()
  }

  /**
   * 选择三级分类改变选中的分类id
   * @param id 三级分类id
   * @param level 三级分类级别
   */
  changeThreeId (id: string, level: string) {
    if (this.threeId === id) return false
    this.params.pageIndex = 1
    this.threeId = id
    this.currentLevel = level
    this.getGoodsList()
  }

  getContainer () {
    return document.querySelector('.goods-container');
  }

  /**
   * 排序方式
   * @param val
   */
  changeSortValue (val: string) {
    if (val === '') {
      this.orderField = ''
      this.orderType = ''
    } else {
      const typeArr = val.split('-')
      this.orderField = typeArr[0]
      this.orderType = typeArr[1]
    }
    this.getGoodsList()
  }

  /**
   * 获取分类筛选下商品列表
   */
  getGoodsList () {
    // 获取请求对象（请求接口，请求参数）
    let apiObj = this.getApiObj()
    apiObj.api(apiObj.params).then((res) => {
      this.refreshing = false
      this.shopGoodsList = (res.data && res.data.records) || []
      if (this.shopGoodsList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false
      }
    }).catch(() => {
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getGoodsList()
  }

  /**
   * 上拉加载更多
   * */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    // 获取请求对象（请求接口，请求参数）
    let apiObj = this.getApiObj()
    apiObj.api(apiObj.params).then((res) => {
      this.loading = false
      const data = (res.data && res.data.records) || []
      this.shopGoodsList = this.shopGoodsList.concat(data)
      if (this.shopGoodsList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false
      }
    }).catch(() => {
      this.loading = false
    })
  }

  /**
   * @description: 获取请求对象（请求接口，请求参数）
   * @param {*}
   * @return {*}
   */
  getApiObj () {
    let params // 请求参数
    let api //  请求接口
    switch (this.categoryId) {
      //  新品上架/热卖推荐不需要品牌和标签查询条件
      case 'xpsj':
      case 'rmtj':
        params = {
          customerId: this.companyId,
          shopId: this.providerId,
          orderField: this.orderField,
          orderType: this.orderType,
          ...this.params
        }
        api = this.categoryId === 'xpsj' ? newArrivalList : hotSaleList
        break;
      default:
        params = {
          categoryId: this.currentLevel === '3' ? this.threeId : this.categoryId,
          customerId: this.companyId,
          shopId: this.providerId,
          orderField: this.orderField,
          orderType: this.orderType,
          ...this.params,
          brandIdList: this.brandValue.map((item) => {
            return { brandId: item }
          }),
          tagIdList: this.tagValue.map((item) => {
            return { tagId: item }
          })
        }
        api = getGoodsListOfCategory
    }
    return { api, params }
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getGoodsList()
  }

  /**
   * 获取初始化下拉选项
   */
  getBrandList () {
    const obj = {
      companyId: this.providerId,
      isPage: false
    }
    getShopGoodsBrandList(obj, false).then((res) => {
      this.brandList = res.data
    })
    getShopGoodsTagList(obj, false).then((res => {
      this.tagList = res.data
    }))
  }

  toBuyCar () {
    this.$router.push('/buyCar')
  }

}
